module.exports = __webpack_public_path__ + "img/settings_edit_gateway_dialog.b1ba1f8b.png";